module.exports = __webpack_public_path__ + "static/img/serviceBg5.cdadf2fc.png";